import { TableColumn } from '../../../../components/DataTable/TableColumn';
import { Refund, RefundStatus } from '../../../../interfaces/Refund/Refund';
import { TextColumn } from '../../../../components/DataTable/TextColumn';
import { Pagination } from '../../../../interfaces/Pagination';
import { DataTable } from '../../../../components/DataTable/DataTable';

const refundNameMap: Record<RefundStatus, string> = {
  PENDING: 'Bekleniyor',
  SUCCESS: 'Onaylandı',
  REJECTED: 'Reddedildi',
};

const columns: TableColumn<Refund>[] = [
  {
    id: 'name',
    name: 'Ürün',
    accessor: (row) => <TextColumn value={row.name} />,
  },
  {
    id: 'status',
    name: 'Durum',
    accessor: (row) => (
      <TextColumn value={refundNameMap[row.status] ?? 'Bilinmeyen'} />
    ),
  },
];

type RefundsTableProps = {
  refunds: Refund[];
  totalCount: number;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
  loading: boolean;
};

export const RefundsTable = ({
  refunds,
  totalCount,
  pagination,
  onPagination,
  loading,
}: RefundsTableProps) => {
  return (
    <DataTable
      columns={columns}
      totalCount={totalCount}
      rows={refunds}
      limit={pagination.pageSize}
      setLimit={(newLimit) => onPagination({ page: 0, pageSize: newLimit })}
      page={pagination.page}
      setPage={(newPage) => onPagination({ ...pagination, page: newPage })}
      loading={loading}
    />
  );
};
